const defaultButtonLabel = 'Select Colors and create a bundle';
const minimumBundleSize = 2;
let atcButton;
let bundlerColors = [];
let bundlerColorInputs;
let bundlerImageCount = 0;
let bundlerImages;
let bundlerOptions;
let bundlerSize;
let bundlerSizeInputs;

/**
 * Hook up all bundler event listeners.
 */

window.addEventListener('load', function() {
  atcButton = document.querySelector('.js-atc_button');
  bundlerColorInputs = document.querySelectorAll('.js-bundler_color_input');
  bundlerImages = document.querySelector('.js-bundler_images');
  bundlerOptions = document.querySelectorAll('.js-bundler_options');
  bundlerSizeInputs = document.querySelectorAll('.js-bundler_size_input');

  for (let i = 0; i < bundlerSizeInputs.length; i += 1) {
    const input = bundlerSizeInputs[i];

    if (input.checked) {
      bundlerSize = input.value;
      break;
    }
  }

  /**
   * Listen for color input changes and add/remove the associated variant image to/from the left/top.
   */

  if (!!(bundlerColorInputs) && bundlerColorInputs.length > 0) {
    bundlerColorInputs.forEach((input) => {
      input.addEventListener('change', function() {
        if (this.checked) {
          const bundlerIndex = (this.hasAttribute('data-bundler-index')) ? this.getAttribute('data-bundler-index') : '';
          const optionIndex = (this.hasAttribute('data-option-index')) ? this.getAttribute('data-option-index') : '';
          const optionName = (this.hasAttribute('data-option-name')) ? this.getAttribute('data-option-name') : '';
          const options = document.querySelectorAll(`.js-bundler_options[data-size="${bundlerSize}"] .js-bundler_option[data-bundler-index="${bundlerIndex}"][data-option-index="${optionIndex}"] .js-bundler_color_input`);
          const variantId = this.value;
          const variantImageURL = (this.hasAttribute('data-variant-image-url')) ? this.getAttribute('data-variant-image-url') : '';

          this.checked = true;
          this.nextElementSibling.checked = true;
          this.parentElement.parentElement.classList.add('is-selected');

          if (!!(bundlerImages)) {
            bundlerImageCount += 1;
            bundlerImages.insertAdjacentHTML('beforeend', `<img src="${variantImageURL}" data-option-id="${this.id}">`);
            bundlerImages.classList.add('bundler_images--has-images');
          }

          const nameElement = this.parentElement.parentElement.parentElement.previousElementSibling.querySelector('.nt_name_current');

          if (!!(nameElement)) {
            nameElement.innerText = optionName;
          }

          if (!!(options) && options.length > 0) {
            setTimeout(() => {
              options.forEach((option) => {
                if (option.value != variantId) {
                  option.checked = false;
                  option.parentElement.parentElement.classList.remove('is-selected');
                  option.nextElementSibling.checked = false;

                  const bundlerImage = document.querySelector(`.js-bundler_images img[data-option-id="${option.id}"]`);

                  if (!!(bundlerImage)) {
                    bundlerImage.remove();
                    bundlerImageCount -= 1;

                    if (bundlerImageCount == 0 && !!(bundlerImages)) {
                      bundlerImages.classList.remove('bundler_images--has-images');
                    }

                    if (bundlerImageCount < minimumBundleSize && !!(atcButton)) {
                      atcButton.children[0].innerText = defaultButtonLabel;
                      atcButton.disabled = true;
                    }
                  }
                }
              });

              if (bundlerImageCount >= minimumBundleSize && !!(atcButton)) {
                const buttonLabel = (atcButton.hasAttribute('data-label')) ? atcButton.getAttribute('data-label') : '';

                atcButton.children[0].innerText = buttonLabel;
                atcButton.disabled = false;
              }
            }, 250);
          }
        } else {
          this.checked = false;
          this.nextElementSibling.checked = false;
          this.parentElement.parentElement.classList.remove('is-selected');

          const nameElement = this.parentElement.parentElement.parentElement.previousElementSibling.querySelector('.nt_name_current');

          if (!!(nameElement)) {
            nameElement.innerText = '';
          }

          const bundlerImage = document.querySelector(`.js-bundler_images img[data-option-id="${this.id}"]`);

          if (!!(bundlerImage)) {
            bundlerImage.remove();
            bundlerImageCount -= 1;

            if (bundlerImageCount == 0 && !!(bundlerImages)) {
              bundlerImages.classList.remove('bundler_images--has-images');
            }
          }

          if (bundlerImageCount < minimumBundleSize && !!(atcButton)) {
            atcButton.children[0].innerText = defaultButtonLabel;
            atcButton.disabled = true;
          }
        }
      });
    });
  }

  /**
   * Listen for size input changes and reset bundle color options (because the color could be out of stock for the size chosen).
   */

  if (!!(bundlerSizeInputs) && bundlerSizeInputs.length > 0) {
    bundlerSizeInputs.forEach((input) => {
      input.addEventListener('change', function() {
        bundlerSize = this.value;

        if (this.checked) {
          bundlerImageCount = 0;

          if (!!(bundlerImages)) {
            bundlerImages.innerHTML = '';
            bundlerImages.classList.remove('bundler_images--has-images');
          }

          if (!!(atcButton)) {
            atcButton.children[0].innerText = defaultButtonLabel;
            atcButton.disabled = true;
          }

          this.parentElement.parentElement.classList.add('is-selected');

          const nameElement = this.parentElement.parentElement.parentElement.previousElementSibling.querySelector('.nt_name_current');

          if (!!(nameElement)) {
            nameElement.innerText = bundlerSize;
          }
        }

        if (!!(bundlerSizeInputs) && bundlerSizeInputs.length > 0) {
          setTimeout(() => {
            bundlerSizeInputs.forEach((sizeInput) => {
              if (sizeInput.value != bundlerSize) {
                sizeInput.checked = false;
                sizeInput.parentElement.parentElement.classList.remove('is-selected');
              }
            });
          }, 250);
        }

        if (!!(bundlerOptions) && bundlerOptions.length > 0) {
          bundlerOptions.forEach((option) => {
            const size = (option.hasAttribute('data-size')) ? option.getAttribute('data-size') : '';

            if (size == bundlerSize) {
              option.classList.remove('bundler_options--is-hidden');
            } else {
              option.classList.add('bundler_options--is-hidden');
            }
          });
        }

        if (!!(bundlerColorInputs) && bundlerColorInputs.length > 0) {
          bundlerColorInputs.forEach((colorInput) => {
            colorInput.checked = false;
            colorInput.nextElementSibling.checked = false;
            colorInput.parentElement.parentElement.classList.remove('is-selected');

            const nameElement = colorInput.parentElement.parentElement.parentElement.previousElementSibling.querySelector('.nt_name_current');

            if (!!(nameElement)) {
              nameElement.innerText = '';
            }
          });
        }
      });
    });
  }
});